import React from "react";
import { makeStyles, Box, Typography, CircularProgress, Paper } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  root: {
    position: "fixed",
    left: 0,
    top: 0,
    width: "100%",
    height: "100%",
    zIndex: 2000,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "rgba(255,255,255,0.85)",
    backdropFilter: "blur(2px)",
  },
  card: {
    background: "#ffffff",
    border: "1px solid #e9ecef",
    borderRadius: 16,
    padding: theme.spacing(3),
    boxShadow: "0 8px 24px rgba(0,0,0,0.12)",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: theme.spacing(1.5),
  },
  spinner: {
    color: "#1d649c",
  },
}));

export default function PageLoading() {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <Paper elevation={0} className={classes.card}>
        <CircularProgress size={56} thickness={4.2} className={classes.spinner} />
        <Typography variant="body2" style={{ color: "#1a1a1a", fontWeight: 500 }}>Loading...</Typography>
      </Paper>
    </div>
  );
}
